<template lang="pug">
.section
  .section-header
    .section-header-back(v-if="layerLevel != 1 && !isOperator")
      a.btn.btn-sm.btn-icon(href="javascript:void(0)" @click="layerLevel -= 1")
        i.fas.fa-arrow-left
    h1 {{ $t("ui.ticket_voucher_list_member") }}
  .section-body
    .row
      .col-12
        template(v-if="layerLevel == 1")
          operatorlist(typeTicketListOperator="ticketlistop" @changeLayer="changeLayer")
        template(v-else-if="layerLevel == 2")
          memberticketvoucherlist
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import operatorlist from "@/components/ticketvoucher/operatorList.vue";
import memberticketvoucherlist from "@/components/ticketvoucher/memberTicketVoucherList.vue";

export default {
  components: {
    operatorlist,
    memberticketvoucherlist
  },
  data: () => ({
    loading: false,
    layerLevel: 1,
    feedback: {
      success: false,
      status: errorTags.request.failed
    }
  }),
  computed: {
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    }
  },
  mounted: function() {
    if(this.isOperator) {
      this.$store.dispatch("user/setSelectedOperatorID", this.$store.getters.accountId);
      this.layerLevel = 2;
    }
  },
  methods: {
    changeLayer(layer) {
      this.layerLevel = layer;
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>